import React from "react";
import './pie-chart.scss';
// import { PieChart } from 'react-minimal-pie-chart';

import { PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';

class MyPieChart extends React.Component {

    constructor(props) {
        super(props)
        console.log(this.props.data)
        this.state = {
            data: this.props.data
        }
    }


    render() {

        //   const data = [
        //     { name: 'A', value: 44 },
        //     { name: 'B', value: 15 },
        //     { name: 'C', value: 19 }
        //   ];

        const COLORS = ['#6B52C8', '#FF9501', '#FFC928'];

        const RADIAN = Math.PI / 180;

        // Function to show % inside slices
        const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
            const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
            const x = cx + radius * Math.cos(-midAngle * RADIAN);
            const y = cy + radius * Math.sin(-midAngle * RADIAN);

            return (
                <text
                  x={x}
                  y={y}
                  fill="white"
                  textAnchor="middle"
                  dominantBaseline="central"
                  fontWeight="bold"
                  fontSize={32} // <--- increase this to make text larger
                >
                  {`${Math.round(percent * 100)}%`}
                </text>
              );
        };

        return (
            <PieChart width={400} height={400}>
                <Pie
                    data={this.state.data}
                    cx="50%"
                    cy="50%"
                    labelLine={false}
                    label={renderCustomizedLabel}
                    outerRadius={180}
                    dataKey="value"
                    startAngle={90}
                    endAngle={-270}

                >
                    {this.state.data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} stroke="#fff" strokeWidth={2} />
                    ))}
                </Pie>
                <Tooltip />
            </PieChart>
        );
    }
}

export default MyPieChart;